// extracted by mini-css-extract-plugin
module.exports = {"results":"styles__results--1PKoU","resultItem":"styles__resultItem--1AzDQ","resultLink":"styles__resultLink--3WSd-","resultLinkAll":"styles__resultLinkAll--3tFIR","resultIcon":"styles__resultIcon--3uh8e","resultTitle":"styles__resultTitle--2aDPx","quickLinksWrapper":"styles__quickLinksWrapper--3ZuO5","quickLink":"styles__quickLink--2siFq"};
    if(module.hot) {
      // 1545480340756
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  